import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { Text } from '@typedream/ui';
import Tooltip from '../../sharedComponents/TextEditor/components/Tooltip';

function SidebarItem({
  left,
  center,
  right,
  onClick,
  onClickCenter,
  link,
  className,
  selected,
  containerClassname,
  disabled,
  tooltip,
}: {
  left?: any;
  center: any;
  right?: any;
  onClick?: () => void;
  onClickCenter?: () => void;
  link?: string;
  className?: string;
  selected?: boolean;
  containerClassname?: string;
  disabled?: boolean;
  tooltip?: string;
}) {
  const content = (
    <div
      className={classNames(
        'w-full flex items-center justify-between rounded-md cursor-pointer px-0.5 py-1 my-1',
        {
          'opacity-50': disabled,
          'bg-background-highlight': selected,
          'bg-transparent': !selected,
          'hover:bg-background-highlight': !disabled,
        },
        containerClassname
      )}
      data-testid="SidebarItem_container"
      onClick={onClick}
      role="none"
    >
      <div className={left && 'mx-[10px] text-secondary flex items-center justify-center'}>
        {left}
      </div>
      <div
        className={classNames('flex-1 whitespace-nowrap overflow-hidden text-ellipsis', className)}
        role="none"
        onClick={onClickCenter}
      >
        <Text size="2xs" weight="medium">
          {center}
        </Text>
      </div>
      <div className="mx-[10px] text-secondary flex items-center justify-center">{right}</div>
    </div>
  );
  const component = link ? (
    <Link href={link} legacyBehavior>
      {content}
    </Link>
  ) : (
    content
  );
  return tooltip ? <Tooltip center={tooltip}>{component}</Tooltip> : component;
}

SidebarItem.defaultProps = {
  left: undefined,
  right: undefined,
  onClick: undefined,
  onClickCenter: undefined,
  link: undefined,
  className: undefined,
  selected: undefined,
  containerClassname: undefined,
  disabled: undefined,
};

export default SidebarItem;
